import { useQuery } from "@tanstack/react-query";

import { useSelectedWorkspaceContext } from "common/context/SelectedWorkspaceContext";
import { get } from "common/helpers/HTTP";

async function getInboxWsToken(workspaceId: string): Promise<string> {
  return (await get(`workspaces/${workspaceId}/unread-token`)).token;
}

export default function useInboxWsToken() {
  const { id } = useSelectedWorkspaceContext();

  const { data: inboxWsToken } = useQuery({
    queryKey: ["inboxWsToken", id],
    queryFn: () => getInboxWsToken(id),
    staleTime: Infinity,
  });

  return { inboxWsToken };
}
